module.exports = __webpack_public_path__ + "static/media/hospedagem-animacao.46a6e115.mp4";